export const capitalizeStr = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const camelToSnake = (str: string): string => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
};
